import { AnyAction, applyMiddleware, createStore, Store, StoreEnhancer } from "redux";
import thunk from "redux-thunk";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import config from "./config";
import rootReducer from "./reducers";
import CartBrowserStorageService from "./services/CartBrowserStorageService";

/* eslint-disable global-require, @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires */

const getEnhancers = (): StoreEnhancer => {
    if (config.NODE_ENV_IS_PROD) {
        return applyMiddleware(
            thunk,
        );
    }

    // Only import these dependencies in local environments. Tree shaking should exclude it from PROD builds.
    // Enable integration with the Redux dev tools Chrome extension.
    const { composeWithDevTools } = require("redux-devtools-extension");
    const reduxUnhandledAction = require("redux-unhandled-action").default;
    const reduxImmutableStateInvariant = require("redux-immutable-state-invariant").default;

    return composeWithDevTools(applyMiddleware(
        reduxUnhandledAction((action: AnyAction) => console.warn("Action was dispatched, but state did not change.", action)),
        reduxImmutableStateInvariant(), // Ensures reducers NEW objects instead of mutating existing objects.
        thunk, // Allows actions to return functions for asynchronous purposes.
    ));
};

const persistConfig = {
    key: CartBrowserStorageService.CART_PERSIST_STATE_STORAGE_KEY,
    // If Redux state should be persisted, store it in `localStorage`. Otherwise, define custom storage methods that do nothing.
    // This is used by the ADA test suite, which validate all checkout pages are compliant.
    storage: CartBrowserStorageService.getCartShouldPersistState() ? storage : {
        getItem: () => Promise.resolve(null),
        setItem: () => Promise.resolve(),
        removeItem: () => Promise.resolve(),
    },
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

export default function configureStore(initialState?: {}): Store {
    return createStore(
        persistedReducer,
        initialState,
        getEnhancers(),
    );
}

/* eslint-enable global-require, @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires */
